import { type StoryblokProductSearchFilterDiscountType } from '../../../../storyblok'
import {
  type StoryblokProductSearchFiltersType,
  type StoryblokProductSearchRangeType,
} from '../StoryblokProductSearchFilters.types'

export const storyblokProductSearchFiltersGetDiscount = (
  discountSearchFilter: StoryblokProductSearchFilterDiscountType,
): Partial<Pick<StoryblokProductSearchFiltersType, 'discountInPercent'>> => {
  const { max, min } = discountSearchFilter

  const discountInPercent: StoryblokProductSearchRangeType = {}

  const parsedMax = Number(max)
  if (max && Number.isFinite(parsedMax)) {
    discountInPercent.max = parsedMax
  }

  const parsedMin = Number(min)
  if (min && Number.isFinite(parsedMin)) {
    discountInPercent.min = parsedMin
  }

  return {
    discountInPercent,
  }
}
